export function getAssetHost() {
  return ASSET_HOST;
}
